module.exports = __webpack_public_path__ + "static/media/sShip2.531b3f59.png";